import { type ComponentProps } from 'react';

import { cn } from '@air/utils-tailwind';

export const MobileTableRowContainer = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('flex rounded-2 px-3', className)} {...props} />
);
